import { Model } from "@vuex-orm/core"
import StudentCourse from "@/models/StudentCourse"
import { notify } from "@/services/notification"

export default class Evaluation extends Model {
  static get entity() {
    return "evaluations"
  }

  static fields() {
    return {
      id: this.attr(null),
      student_course_id: this.attr(null),
      objective: this.attr(""),
      result: this.number(0),
      date: this.attr(""),
      comment: this.attr(""),
      student_course: this.belongsTo(StudentCourse, "student_course_id"),
    }
  }

  static async getOneByStudentCourseId(student_course_id) {
    return await this.api().get(`/evaluation/student-course/${student_course_id}`, {
      dataKey: "data",
    })
  }

  static async update(evaluation) {
    return await this.api().put(`/evaluation/`, evaluation, {
      dataKey: "data",
    })
  }

  static async create(evaluation) {
    return await this.api().post(`/evaluation`, evaluation)
  }

  static async deleteOne(id) {
    return await this.api()
      .delete(`/evaluation/${id}`, {
        delete: id,
      })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.error)
      })
  }
}
